// extracted by mini-css-extract-plugin
export default {"Page":"Style_Page__i3QfR","Form":"Style_Form__oZ80Y"};